<template>
    <div
        class="lb-project-box"
        @mouseover="shadow = true"
        @mouseleave="shadow = false"
    >
        <span
            v-if="content.pendingChanges"
            class="badge has-background-pink-red"
            >{{ content.pendingChanges }}
        </span>
        <div
            :style="`${background(content.background)}`"
            class="lb-project-background-card"
        />
        <div class="lb-project-background-card shadow">
            <div class="columns is-mobile is-marginless pt-1">
                <div class="column is-9">
                    <!--<div
                    v-if="content.featured && notInExplore"
                        @click.stop.prevent=""
                        class="pl-2 is-pulled-left"
                    >
                        <span
                            class="icon is-small  has-text-white mt-1"
                            :title="$t('featured_project')"
                        >
                            <i
                                class="mdi mdi-24px mdi-star-outline"
                                aria-hidden="true"
                            />
                        </span>
                    </div>-->
                </div>
                <div class="column is-3">
                    <div
                        @click.stop.prevent=""
                        :class="
                            (amOwner || isAdmin) && menu
                                ? 'pl-2 is-pulled-left'
                                : 'is-pulled-right pr-2'
                        "
                    >
                        <span
                            class="icon is-small dropdown-trigger has-text-white mt-1"
                            @click.stop="showShareModal"
                        >
                            <i
                                class="mdi mdi-24px mdi-share"
                                aria-hidden="true"
                            />
                        </span>
                    </div>
                    <div
                        @click.stop.prevent=""
                        v-if="(amOwner || isAdmin) && menu"
                        class="dropdown is-right is-hoverable is-pulled-right"
                    >
                        <span
                            class="icon is-small dropdown-trigger has-text-white mt-1"
                        >
                            <i
                                class="mdi mdi-24px mdi-dots-vertical"
                                aria-hidden="true"
                            />
                        </span>
                        <div class="dropdown-menu" role="menu">
                            <div class="dropdown-content">
                                <div
                                    v-if="canShowViewLink"
                                    class="dropdown-item"
                                    @click.stop.prevent="$emit('view')"
                                >
                                    <a v-t="'dropdown_option_view_project'" />
                                </div>
                                <div
                                    class="dropdown-item"
                                    @click.stop.prevent="$emit('delete')"
                                >
                                    <a v-t="'dropdown_option_delete_project'" />
                                </div>
                                <div
                                    v-if="content.folder && canRemoveFromFolder"
                                    class="dropdown-item"
                                    @click.stop.prevent="
                                        $emit('removeFromFolder')
                                    "
                                >
                                    <a
                                        v-t="
                                            'Project.dropdown_option_remove_from_folder'
                                        "
                                    />
                                </div>
                                <div
                                    v-if="!disableClone"
                                    class="dropdown-item"
                                    @click.stop.prevent="$emit('clone')"
                                >
                                    <a v-t="'dropdown_option_clone_project'" />
                                </div>
                                <!--<div
                                    v-if="canHighlightProject"
                                    class="dropdown-item"
                                    @click.stop.prevent="$emit('highlight')"
                                >
                                    <a v-t="'dropdown_option_featuring_project'" />
                                </div>
                                <div
                                    v-if="canUnhighlightProject"
                                    class="dropdown-item"
                                    @click.stop.prevent="$emit('unhighlight')"
                                >
                                    <a v-t="'dropdown_option_unfeaturing_project'" />
                                </div>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns is-mobile is-marginless pt-1">
            <div class="column is-11 py-0 has-text-left pt-1">
                <p class="is-size-5 lb-card-title is-block has-text-black">
                    {{ getTitle }}
                </p>
                <p
                    class="is-size-7 lb-card-title is-block is-uppercase has-text-eduloc-red"
                >
                    {{ contentType }}
                    <span
                        v-if="!canEdit"
                        :title="$t('no_project_edit_permission')"
                        class="icon is-small has-text-grey mt-0 pb-1"
                    >
                        <i class="mdi mdi-14px mdi-lock" aria-hidden="true" />
                    </span>
                </p>
            </div>
        </div>
        <!--<div class="level">
      <p class="has-text-grey">{{ content.owner.name }}</p>
    </div>-->
    </div>
</template>

<script>
import { projectBackground } from '@/lib/helpers';
import _ from 'underscore';
export default {
    props: {
        content: {
            type: Object,
            default: () => {
                return {};
            },
        },
        menu: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            showToolbar: false,
            shadow: false,
        };
    },
    computed: {
        background() {
            return (bg) => {
                if (
                    this.content.type == 'treasurehunt' ||
                    this.content.type == 'scape' ||
                    this.content.mode == 'map' || !bg
                ) {
                    return projectBackground(
                        !_.isEmpty(this.content.image)
                            ? this.content.image
                            : !_.isEmpty(this.content.backgroundImage)
                            ? this.content.backgroundImage
                            : {
                                  url:
                                      process.env.VUE_APP_ROOT_URL +
                                      '/img/project-default.png',
                              }
                    );
                }
                return projectBackground(
                    !_.isEmpty(this.content.image)
                        ? this.content.image
                        : !_.isEmpty(this.content.backgroundImage)
                        ? this.content.backgroundImage
                        : bg
                );
            };
        },
        amOwner() {
            if (typeof this.content.owner === 'object') {
                return (
                    this.content.owner.owner === this.$store.getters.user.owner
                );
            } else {
                return this.content.owner === this.$store.getters.user.owner;
            }
        },
        canRemoveFromFolder() {
            return this.amOwner && this.$route.name == "dashboard-folder";
        },
        canHighlightProject() {
            return this.$store.getters.isAdmin && this.$route.name != "explorer" && !this.content.featured;
        },
        canUnhighlightProject() {
            return this.$store.getters.isAdmin && this.$route.name == "explorer" && this.content.featured;
        },
        isAdmin() {
            // console.log(this.$store.getters.isAdmin)
            if (
                this.content.accessLevel &&
                this.content.accessLevel == 'administrator'
            ) {
                return true;
            }
            return this.$store.getters.isAdmin;
        },
        contentType() {
            if (
                this.content.type == 'collection' &&
                this.content.mode == 'map'
            ) {
                return this.$t(`Creation.contentmap.title`);
            } else if (
                this.content.type == 'trivial' &&
                this.content.mode == 'map'
            ) {
                return this.$t(`Creation.trivialgeo.title`);
            } else return this.$t(`Creation.${this.content.type}.title`);
        },
        canShowViewLink() {
            if (
                this.content.accessLevel &&
                this.content.accessLevel != 'read' &&
                this.content.type == 'collection' &&
                this.content.mode == 'map'
            ) {
                return true;
            }
            return false;
        },
        canEdit() {
            if(!this.$store.getters.isLoggedIn || this.$store.getters.isAnonymous){
                if(this.content.allowAnonymous==true && this.content.defaultPermission!='read'){
                    return true;
                }
            }else if (
                this.$store.getters.isLoggedIn &&
                !this.$store.getters.isAnonymous &&
                this.content.accessLevel &&
                this.content.accessLevel != 'read'
            ) {
                return true;
            }
            return false;
        },
        notInExplore() {
            return this.$route.name != "explorer"
        },
        disableClone() {
            //console.log(this.content.format, (this.enabledTypes.indexOf(this.content.format)===-1 || (this.projectTypeMaxNumber <= this.projectTypeNumber[this.content.format] && this.projectTypeMaxNumber!=-1)))
            return (this.enabledTypes.indexOf(this.content.format)===-1 || (this.projectTypeMaxNumber <= this.projectTypeNumber[this.content.format] && this.projectTypeMaxNumber!=-1))
        },
        projectTypeNumber() {
            return this.$store.getters.user ? this.$store.getters.user.data.projectsPerType : [];
        },
        projectTypeMaxNumber() {
            return this.$store.getters.activePlan ? this.$store.getters.activePlan.configuration.project.perTypeMaxNumber : 0
        },
        enabledTypes() {
            return this.$store.getters.activePlan ? this.$store.getters.activePlan.configuration.project.type : []
        },
        isMultilang() {
            return this.content.langs && this.content.langs.length > 0;  
        },
        getTitle() {
            // console.log("buscat títol")
            if (this.isMultilang) {
                let locale = this.$i18n.locale;
                if (locale == 'ca-ES') {
                    locale = "ca";
                }
                const defaultLang = this.content.defaultLang;
                // console.log("title locale", locale)
                if (this.content.titlePerLang && this.content.titlePerLang[locale]) {
                    // console.log("returning active locale ",this.content.titlePerLang[this.activeLang])
                    return this.content.titlePerLang[locale];
                }  else if (defaultLang && this.content.titlePerLang && this.content.titlePerLang[defaultLang]) {
                    // console.log("title returning default")
                    return this.content.titlePerLang[defaultLang]
                } else {
                    return this.content.title;
                }
                // console.log("no title")
            } else {
                return this.content.title;
            }
        }
    },
    methods: {
        showShareModal() {
            this.$emit('show-share-modal', this.content);
        },
    },
};
</script>

<style scoped>
.level {
    padding: 0 0.5em;
}
.edit-button {
    text-shadow: 0px 2px 4px #000;
}
.lb-card-title {
    max-width: 100%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.lb-project-background {
    transition: 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
}
.lb-project-background {
    transform: scale(1, 1.035);
}

.lb-project-background {
    width: 100%;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
}
.toolbar {
    position: absolute;
    top: -25px;
    right: 10px;
}
.badge {
    z-index: 2;
    height: 30px;
    min-width: 30px;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    right: 32px;
    line-height: 24px;
    box-shadow: none;
}
.dropdown.is-right.is-hoverable {
    vertical-align: middle;
}
.mdi-14px.mdi-set,
.mdi-14px.mdi:before {
    font-size: 14px;
}
.shadow {
    background: rgb(91, 91, 91);
    background: linear-gradient(
        180deg,
        rgba(91, 91, 91, 1) 0%,
        rgba(0, 0, 0, 0) 100%
    );
    position: absolute;
    top: 0;
    width: 100%;
    height: 55px;
    box-shadow: none;
}
.dropdown-item a:hover{
    color: #000000;
}
.dropdown-item:hover{
    cursor: pointer;
    background-color: var(--eduloc-grey-light);
}
.dropdown-content{
    padding:0;
    border-radius: 0;
}
</style>
